// extracted by mini-css-extract-plugin
export default {"judgment-form":"events-editing-client-js-editing-timeline-___ReviewForm-module__judgment-form___3Xo6t"};